import React from 'react';
import styled from 'styled-components';
import { space } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { useSelector } from 'react-redux';
import AuthSwitch from 'components/auth-switch';
import WarningNotification from 'components/warning-notification';
import Documents from 'components/billing/documents';
import TopNav from 'components/billing/top-nav';
import Header from 'theme/header';
import Body from 'theme/layouts/body';
import Text from 'theme/text';
import translations from 'translations';
import TopBar from 'components/top-bar';

const Wrapper = styled.div`
  ${space}

  min-width: 1024px;
`;

const StyledWarningNotification = styled(WarningNotification)`
  padding: ${themeGet('space.l')}px ${themeGet('space.l')}px 0;
`;

function BillingPage() {
  const { languageCode } = useSelector((state) => state.config);

  return (
    <AuthSwitch>
      <TopBar />
      <Wrapper pb="xxl">
        <Body bg="primary_50" height="100%" />

        <Header
          bg="white"
          title={translations[languageCode]['Billing Tax Documents']}
          style={{
            bg: 'white',
            borderWidth: '0',
            borderBottomWidth: '1px',
            borderColor: 'primary_200',
            borderStyle: 'solid',
          }}
          componentLeft={
            <Text
              ml="l"
              fontSize="h2"
              lineHeight="h2"
              fontWeight="bold"
              color="grey_600"
              textAlign="left"
            >
              {translations[languageCode].billing}
            </Text>
          }
        />

        <TopNav activeKey="documents" />

        <StyledWarningNotification />

        <Documents />
      </Wrapper>
    </AuthSwitch>
  );
}

export default BillingPage;
